import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Document } from "../../common/models/document";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class DocumentService {
  constructor(
    private api: ApiBaseService,
    private currentUser: CurrentUser,
  ) {}

  public getByAthlete(organization: Organization, athlete: Athlete): Observable<any> {
    return this.api.call('get',`organizations/${organization.code}/athletes/${athlete.userId}/documents?limit=3`, {}, this.currentUser.getAccessToken());
  }

  public getByAthletePaginated(organization: Organization, athlete: Athlete, page = 0, query = ''): Observable<any> {
    return this.api.call('get',`organizations/${organization.code}/athletes/${athlete.userId}/documents?page=${page}&q=${query}`, {}, this.currentUser.getAccessToken());
  }

  public rename(organization: Organization, athlete: Athlete, documentId: number, fileName: string): Observable<any> {
    return this.api.call('patch',
      `organizations/${organization.code}/athletes/${athlete.userId}/documents/${documentId}`,
      {'originalName': fileName},
      this.currentUser.getAccessToken()
    );
  }

  public deleteById(organization: Organization, athlete: Athlete, documentId: number): Observable<any> {
    return this.api.call('delete',`organizations/${organization.code}/athletes/${athlete.userId}/documents/${documentId}`, {}, this.currentUser.getAccessToken());
  }

  public download(organization: Organization, athlete: Athlete, document: Document): Observable<any> {
    return this.api.call('get',`organizations/${organization.code}/athletes/${athlete.userId}/documents/${document.id}`, {
        responseType: 'blob'
      },
      {
        accessToken: this.currentUser.getAccessToken(),
        resultType: 'file'
      },
      false,
    );
  }
}
